import type React from 'react';
import { displayTime } from './attendance-page.utils';
import { useAttendancePageController } from './useAttendancePageController';

export const AttendancePage: React.FC = () => {
  const {
    user,
    from,
    setFrom,
    to,
    setTo,
    rows,
    isLoading,
    hasMore,
    isLoadingMore,
    onLoadMore,
    error,
  } = useAttendancePageController();

  return (
    <section className="workforcePage" dir="rtl">
      <div className="workforceHeader">
        <div>
          <h1>נוכחות</h1>
        </div>
      </div>
      <div className="workforceToolbar">
        <label>
          מתאריך
          <input type="date" value={from} onChange={(event) => setFrom(event.target.value)} />
        </label>
        <label>
          עד תאריך
          <input type="date" value={to} onChange={(event) => setTo(event.target.value)} />
        </label>
      </div>
      {error && <p className="errorText">{error}</p>}
      <div className="reportTableWrap">
        <table role="table" className="reportTable attendanceTable">
          <caption>רישומי נוכחות</caption>
          <thead>
            <tr>
              {user?.role === 'manager' && <th>עובד</th>}
              <th>תאריך</th>
              <th>מחלקה</th>
              <th>כניסה</th>
              <th>יציאה</th>
              <th>מצב</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                {user?.role === 'manager' && (
                  <td data-label="עובד">
                    <strong>{row.employeeName}</strong>
                  </td>
                )}
                <td data-label="תאריך">{row.date}</td>
                <td data-label="מחלקה">
                  {row.roleName}
                </td>
                <td data-label="כניסה">
                  {displayTime(row.startShiftAt)}
                </td>
                <td data-label="יציאה">
                  {row.endShiftAt ? displayTime(row.endShiftAt) : '-'}
                </td>
                <td data-label="מצב">
                  <span className={`reportStatus ${row.endShiftAt ? 'yes' : 'no'}`}>
                    {row.endShiftAt ? 'סגורה' : 'פתוחה'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!isLoading && rows.length === 0 && <p className="reportsState">אין רישומי נוכחות בטווח שנבחר.</p>}
      </div>
      {isLoading && <p className="reportsState">טוען נתוני נוכחות...</p>}
      {hasMore && !isLoading && <button type="button" className="secondaryAction" disabled={isLoadingMore} onClick={() => void onLoadMore()}>טעינת רישומים נוספים</button>}
    </section>
  );
};
